import "./vendor/jquery"
import "./vendor/lodash"
import {} from "jquery-ujs"
import "jquery-validation/dist/jquery.validate"
import "jquery-validation/dist/localization/messages_pl"
import { Application } from "@hotwired/stimulus"

import "./partials/client/analytics/track-event"
import "./partials/client/analytics/form-tracking"
import "./partials/client/analytics/newsletter"
import "./partials/client/analytics/link-tracking"
import "./partials/client/fb-events"
import "./partials/client/main-nav"
import "./partials/client/cart-dropdown"
import "./partials/client/job-offers"
import "./partials/client/social-share"
import "./partials/client/floating-contact"
import "./partials/client/faq"
import "./partials/client/remote-handlers"
import "./partials/client/clipboard"
import "./partials/client/modals"
import "./partials/client/turnstile"
import "./partials/client/personal-data-form"
import "./partials/client/discount-form"
import "./partials/client/info-bubble"
import "./partials/client/order-summary"
import "./partials/client/swiper"
import "./partials/client/product-info"
import "./partials/client/scroll-to-hash"
import "./partials/client/configurator"
import "./partials/client/tabs"
import "./partials/client/order-status-form"
import "./partials/client/sample-form"
import "./partials/client/analytics/google-analytics"
import "./partials/client/analytics/gtm-new-products-list-event"
import "./partials/client/landing-page-countdown"
import "./partials/client/how-to"
import "./partials/client/slider-banner"
import "./partials/client/drawers-and-organizers"
import "./partials/client/santender-installment-calculator"
import "./partials/client/fronts-presentation-menu"
import "./partials/client/panels-presentation-menu"
import "./partials/client/handles-presentation-menu"
import "./partials/client/front-presentation-selector"
import "./partials/client/yl-recommendation-frames-customiser"
import "./partials/client/simple-collapsible"
import "./partials/client/single-letter-words"
import "./partials/client/steps-nav"
import "./partials/client/gallery"
import "./partials/client/file-attachment"
import "./partials/client/service-form"
import "./partials/client/slim-select"
import "./partials/client/cart-sortable"
import "./partials/client/cart-bulk-update"
import "./partials/client/discontinued-colors-modal"
import "./partials/client/form-error-clearing"

import { FetchRequest } from "@rails/request.js"
window.FetchRequest = FetchRequest

import YouLeedController from "./controllers/youleed_controller.js"
window.Stimulus = Application.start()
window.Stimulus.register("youleed", YouLeedController)
